import { Container, Title, Text, Stack, Box, List, Table, Group } from '@mantine/core';
import { IconTruck } from '@tabler/icons-react';
import { useLanguage } from '@/context/LanguageContext';
import { useSEO } from '@/lib/useSEO';

export default function ShippingPage() {
  const { t } = useLanguage();

  // SEO for Shipping page
  useSEO({
    title: t('seo.shipping.title') || 'Shipping Information - Luxelo',
    description: t('seo.shipping.description') || 'Learn about our shipping options, delivery times, and costs. Fast InPost and courier delivery available.',
    type: 'website',
  });

  return (
    <Container size="xl" py="xl">
      <Stack gap="xl">
        <Box>
          <Title order={1} mb="md">{t('shipping.title')}</Title>
          <Text size="lg" c="dimmed">
            {t('shipping.subtitle')}
          </Text>
        </Box>

        <Box>
          <Title order={2} mb="md">{t('shipping.options.title')}</Title>
          <Text size="md" mb="md">
            {t('shipping.options.description')}
          </Text>
        </Box>

        <Box>
          <Title order={3} mb="md">{t('shipping.inpost.title')}</Title>
          <Group gap="md" align="flex-start" mb="md">
            <IconTruck size={24} style={{ color: '#228be6', marginTop: '4px', flexShrink: 0 }} />
            <Box style={{ flex: 1 }}>
              <Text mb="xs">{t('shipping.inpost.description')}</Text>
              <List spacing="xs" size="sm" c="dimmed">
                <List.Item>{t('shipping.inpost.advantage1')}</List.Item>
                <List.Item>{t('shipping.inpost.advantage2')}</List.Item>
                <List.Item>{t('shipping.inpost.advantage3')}</List.Item>
              </List>
            </Box>
          </Group>
        </Box>

        <Box>
          <Title order={3} mb="md">{t('shipping.courier.title')}</Title>
          <Group gap="md" align="flex-start" mb="md">
            <IconTruck size={24} style={{ color: '#228be6', marginTop: '4px', flexShrink: 0 }} />
            <Box style={{ flex: 1 }}>
              <Text mb="xs">{t('shipping.courier.description')}</Text>
              <List spacing="xs" size="sm" c="dimmed">
                <List.Item>{t('shipping.courier.advantage1')}</List.Item>
                <List.Item>{t('shipping.courier.advantage2')}</List.Item>
              </List>
            </Box>
          </Group>
        </Box>

        <Box>
          <Title order={2} mb="md">{t('shipping.costs.title')}</Title>
          <Table striped highlightOnHover withTableBorder mb="md">
            <Table.Thead>
              <Table.Tr>
                <Table.Th>{t('shipping.costs.table.method')}</Table.Th>
                <Table.Th>{t('shipping.costs.table.price')}</Table.Th>
                <Table.Th>{t('shipping.costs.table.delivery')}</Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              <Table.Tr>
                <Table.Td>{t('shipping.costs.table.inpost')}</Table.Td>
                <Table.Td>{t('shipping.costs.table.inpostPrice')}</Table.Td>
                <Table.Td>{t('shipping.costs.table.inpostDelivery')}</Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Td>{t('shipping.costs.table.courier')}</Table.Td>
                <Table.Td>{t('shipping.costs.table.courierPrice')}</Table.Td>
                <Table.Td>{t('shipping.costs.table.courierDelivery')}</Table.Td>
              </Table.Tr>
              <Table.Tr>
                <Table.Td>{t('shipping.costs.table.free')}</Table.Td>
                <Table.Td>{t('shipping.costs.table.freePrice')}</Table.Td>
                <Table.Td>{t('shipping.costs.table.freeDelivery')}</Table.Td>
              </Table.Tr>
            </Table.Tbody>
          </Table>
        </Box>

        <Box>
          <Title order={2} mb="md">{t('shipping.tracking.title')}</Title>
          <Text size="md" mb="md">
            {t('shipping.tracking.description')}
          </Text>
        </Box>

        <Box>
          <Title order={2} mb="md">{t('shipping.international.title')}</Title>
          <Text size="md" mb="md">
            {t('shipping.international.description')}
          </Text>
        </Box>

        <Box>
          <Title order={2} mb="md">{t('shipping.questions.title')}</Title>
          <Text size="md">
            {t('shipping.questions.description')}
          </Text>
        </Box>
      </Stack>
    </Container>
  );
}

